import React from "react";
import niclogo from "../Images/niclogo.png";

const Footer = () => {
  return (
    <footer className="w-full bg-[#D3E4F9] border-t border-gray-300">
      <div className="mx-auto max-w-screen-xl p-2 flex items-center justify-center gap-2">
        <span className="text-sm text-[#004676] sm:text-center dark:text-gray-400">
          Designed and Developed By NIC & Stamps and Registration Department
        </span>
        <img src={niclogo} alt="logo" className="w-24 h-auto" />
      </div>
    </footer>
  );
};

export default Footer;
